import { render, staticRenderFns } from "./MasterplanStreetsSettings.vue?vue&type=template&id=65273fd5&"
import script from "./MasterplanStreetsSettings.vue?vue&type=script&lang=js&"
export * from "./MasterplanStreetsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports